import React, { FC } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "gatsby";
import AutomationCards from "../automation-cards";
import { ITransformAutomationProps } from "../../../types";
import "./styles.scss";
import { cleanURL } from "../../../helpers";
import NothingToShow from "../../nothingToShow";

const AutomationCardsContainer: FC<ITransformAutomationProps> = ({ data }) => {
  let list = data?.list || [];

  if (!list.length) return <NothingToShow />;
  return (
    <Row className="automation-card-container">
      <Col sm={12} className="automation-container-header">
        <div className="automation-card-title">
          <div>
            {!!list.length &&
              list[0] &&
              list[0].category &&
              list[0].category.name}
          </div>
        </div>
        {/*<div className='show-more'><Link to={`/automations/${title}`}>Show more</Link></div>*/}
      </Col>
      {list.map((item) => (
        <Col md={6} lg={4} className="p-2">
          <Link to={`/automation/${cleanURL(item.url)}`}>
            <AutomationCards
              title={item.name}
              description={item.long_description}
              icon={item.icon_url}
              rate={item.rate || 5}
              active={item.active || false}
              credit_price={item.credit_price}
              premium_credit_price={item.premium_credit_price}
              type={item.type}
              is_new={item.is_new}
            />
          </Link>
        </Col>
      ))}
    </Row>
  );
};

export default AutomationCardsContainer;
